package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Chevron_down: ImageVector
    get() {
        if (_chevron_down != null) {
            return _chevron_down!!
        }
        _chevron_down = Builder(name = "Chevron_down", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(7.41f, 8.58f)
                lineTo(12.0f, 13.17f)
                lineTo(16.59f, 8.58f)
                lineTo(18.0f, 10.0f)
                lineTo(12.0f, 16.0f)
                lineTo(6.0f, 10.0f)
                lineTo(7.41f, 8.58f)
                close()
            }
        }
        .build()
        return _chevron_down!!
    }

private var _chevron_down: ImageVector? = null
